module.exports = __webpack_public_path__ + "img/icon-file-uploaded.13d1754d.svg";